// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyPanel_container__1SChh","thumb":"CompanyPanel_thumb__1ABsX","content":"CompanyPanel_content__1QFMs","sending":"CompanyPanel_sending__1HQxI"};